<template>
   <div>
     <h1>Conversations</h1>
     <ul>
       <li v-for="conversation in conversations" :key="conversation.id">
         <h2>{{ conversation.title }}</h2>
         <p>{{ conversation.message }}</p>
       </li>
     </ul>
     <form @submit.prevent="addConversation">
       <div>
         <label for="title">Title:</label>
         <input type="text" id="title" v-model="newConversation.title">
       </div>
       <div>
         <label for="message">Message:</label>
         <textarea id="message" v-model="newConversation.message"></textarea>
       </div>
       <button type="submit">Add Conversation</button>
     </form>
   </div>
 </template>
 
 <script>
 import axios from 'axios';
 
 export default {
   data() {
     return {
       conversations: [],
       newConversation: {
         title: '',
         message: '',
       },
     };
   },
   mounted() {
     this.getConversations();
   },
   methods: {
     getConversations() {
       axios.get(this.apiUrl+'/conversations').then(response => {
         this.conversations = response.data;
       });
     },
     addConversation() {
       axios.post(this.apiUrl+'/conversations', this.newConversation).then(response => {
         this.conversations.push(response.data);
         this.newConversation.title = '';
         this.newConversation.message = '';
       });
     },
   },
 };
 </script>
 